<app-table [rows]="rows" [columns]="columns">
    <ng-template #rowTemplate let-row>
        <tr>
            <td>{{row.NotificationType}}</td>
            <td>
                <div class="channels">
                    <app-checkbox [(ngModel)]="row.IsMyRsuEnabled" (stateChange)="update(row, $event)">
                        {{'notification_channelMyRsu' | translate}}
                    </app-checkbox>

                    <app-checkbox [(ngModel)]="row.IsRsuEmailEnabled" (stateChange)="update(row, $event)">
                        {{'notification_channelRsuEmail' | translate}}
                    </app-checkbox>

                    <app-checkbox [(ngModel)]="row.IsSmsEnabled" (stateChange)="update(row, $event)">
                        {{'notification_channelSms' | translate}}
                    </app-checkbox>
                </div>
            </td>
        </tr>
    </ng-template>
</app-table>
